export const SET_CARS = 'SET_CARS'
export const SET_CARS_TYPE = 'SET_CARS_TYPE'
export const SET_CARS_RATE = 'SET_CARS_RATE'
export const SET_UAC_DRIVERS = 'SET_UAC_DRIVERS'

